import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';
import s from './List.module.css';

export function List({ inset, className, ...rest }: HTMLAttributes<HTMLUListElement> & { inset?: boolean }) {
  return <ul className={cx(s.list, inset && s.inset, className)} {...rest} />;
}

/**
 * One row: leading icon, primary and secondary text, trailing value. Pass `link` to make the whole
 * row a link with your router's component, e.g. `link={(p) => <Link href="/x" {...p} />}`.
 */
export function ListItem({
  leading,
  primary,
  secondary,
  trailing,
  className,
  link,
}: {
  leading?: ReactNode;
  primary: ReactNode;
  secondary?: ReactNode;
  trailing?: ReactNode;
  className?: string;
  link?: (props: { className: string; children: ReactNode }) => ReactNode;
}) {
  const content = (
    <>
      {leading && <span className={s.leading}>{leading}</span>}
      <span className={s.main}>
        <span className={s.primary}>{primary}</span>
        {secondary && <span className={s.secondary}>{secondary}</span>}
      </span>
      {trailing !== undefined && <span className={s.trailing}>{trailing}</span>}
    </>
  );
  if (link) return <li className={s.linkRow}>{link({ className: cx(s.item, s.link, className), children: content })}</li>;
  return <li className={cx(s.item, className)}>{content}</li>;
}

export function listItemClass(): string {
  return s.item ?? "";
}

/** Label/value pairs (receipts, rules, round details). */
export function DescriptionList({ items }: { items: [ReactNode, ReactNode][] }) {
  return (
    <dl className={s.dl}>
      {items.map(([k, v], i) => (
        <div key={i} style={{ display: 'contents' }}>
          <dt>{k}</dt>
          <dd>{v}</dd>
        </div>
      ))}
    </dl>
  );
}
